/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AnalyticsStepType,
    AnalyticsStepTypeFromJSON,
    AnalyticsStepTypeFromJSONTyped,
    AnalyticsStepTypeToJSON,
} from './AnalyticsStepType';
import {
    CurrencyBarPoint,
    CurrencyBarPointFromJSON,
    CurrencyBarPointFromJSONTyped,
    CurrencyBarPointToJSON,
} from './CurrencyBarPoint';
import {
    DateMacro,
    DateMacroFromJSON,
    DateMacroFromJSONTyped,
    DateMacroToJSON,
} from './DateMacro';
import {
    MarketingAnalyticsObjectType,
    MarketingAnalyticsObjectTypeFromJSON,
    MarketingAnalyticsObjectTypeFromJSONTyped,
    MarketingAnalyticsObjectTypeToJSON,
} from './MarketingAnalyticsObjectType';
import {
    NumberBarPoint,
    NumberBarPointFromJSON,
    NumberBarPointFromJSONTyped,
    NumberBarPointToJSON,
} from './NumberBarPoint';

/**
 * 
 * @export
 * @interface MarketingAnalytics
 */
export interface MarketingAnalytics {
    /**
     * 
     * @type {DateMacro}
     * @memberof MarketingAnalytics
     */
    date_macro: DateMacro;
    /**
     * 
     * @type {AnalyticsStepType}
     * @memberof MarketingAnalytics
     */
    unit: AnalyticsStepType;
    /**
     * 
     * @type {Date}
     * @memberof MarketingAnalytics
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof MarketingAnalytics
     */
    end_date: Date;
    /**
     * 
     * @type {MarketingAnalyticsObjectType}
     * @memberof MarketingAnalytics
     */
    object: MarketingAnalyticsObjectType;
    /**
     * 
     * @type {Array<CurrencyBarPoint>}
     * @memberof MarketingAnalytics
     */
    sale_referrers: Array<CurrencyBarPoint>;
    /**
     * 
     * @type {Array<CurrencyBarPoint>}
     * @memberof MarketingAnalytics
     */
    sale_sources: Array<CurrencyBarPoint>;
    /**
     * 
     * @type {Array<CurrencyBarPoint>}
     * @memberof MarketingAnalytics
     */
    sale_mediums: Array<CurrencyBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    visit_referrers: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    visit_sources: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    visit_mediums: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarketingAnalytics
     */
    top_engaged_campaigns: Array<string>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_recipients: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_delivered: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_opens: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_unique_clicks: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_total_bounces: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_unsubscribes: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_total_orders: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_unique_orders: Array<NumberBarPoint>;
    /**
     * 
     * @type {Array<NumberBarPoint>}
     * @memberof MarketingAnalytics
     */
    campaign_unique_paid_orders: Array<NumberBarPoint>;
}

export function MarketingAnalyticsFromJSON(json: any): MarketingAnalytics {
    return MarketingAnalyticsFromJSONTyped(json, false);
}

export function MarketingAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingAnalytics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date_macro': DateMacroFromJSON(json['date_macro']),
        'unit': AnalyticsStepTypeFromJSON(json['unit']),
        'start_date': (new Date(json['start_date'])),
        'end_date': (new Date(json['end_date'])),
        'object': MarketingAnalyticsObjectTypeFromJSON(json['object']),
        'sale_referrers': ((json['sale_referrers'] as Array<any>).map(CurrencyBarPointFromJSON)),
        'sale_sources': ((json['sale_sources'] as Array<any>).map(CurrencyBarPointFromJSON)),
        'sale_mediums': ((json['sale_mediums'] as Array<any>).map(CurrencyBarPointFromJSON)),
        'visit_referrers': ((json['visit_referrers'] as Array<any>).map(NumberBarPointFromJSON)),
        'visit_sources': ((json['visit_sources'] as Array<any>).map(NumberBarPointFromJSON)),
        'visit_mediums': ((json['visit_mediums'] as Array<any>).map(NumberBarPointFromJSON)),
        'top_engaged_campaigns': json['top_engaged_campaigns'],
        'campaign_recipients': ((json['campaign_recipients'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_delivered': ((json['campaign_delivered'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_opens': ((json['campaign_opens'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_unique_clicks': ((json['campaign_unique_clicks'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_total_bounces': ((json['campaign_total_bounces'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_unsubscribes': ((json['campaign_unsubscribes'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_total_orders': ((json['campaign_total_orders'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_unique_orders': ((json['campaign_unique_orders'] as Array<any>).map(NumberBarPointFromJSON)),
        'campaign_unique_paid_orders': ((json['campaign_unique_paid_orders'] as Array<any>).map(NumberBarPointFromJSON)),
    };
}

export function MarketingAnalyticsToJSON(value?: MarketingAnalytics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date_macro': DateMacroToJSON(value.date_macro),
        'unit': AnalyticsStepTypeToJSON(value.unit),
        'start_date': (value.start_date.toISOString()),
        'end_date': (value.end_date.toISOString()),
        'object': MarketingAnalyticsObjectTypeToJSON(value.object),
        'sale_referrers': ((value.sale_referrers as Array<any>).map(CurrencyBarPointToJSON)),
        'sale_sources': ((value.sale_sources as Array<any>).map(CurrencyBarPointToJSON)),
        'sale_mediums': ((value.sale_mediums as Array<any>).map(CurrencyBarPointToJSON)),
        'visit_referrers': ((value.visit_referrers as Array<any>).map(NumberBarPointToJSON)),
        'visit_sources': ((value.visit_sources as Array<any>).map(NumberBarPointToJSON)),
        'visit_mediums': ((value.visit_mediums as Array<any>).map(NumberBarPointToJSON)),
        'top_engaged_campaigns': value.top_engaged_campaigns,
        'campaign_recipients': ((value.campaign_recipients as Array<any>).map(NumberBarPointToJSON)),
        'campaign_delivered': ((value.campaign_delivered as Array<any>).map(NumberBarPointToJSON)),
        'campaign_opens': ((value.campaign_opens as Array<any>).map(NumberBarPointToJSON)),
        'campaign_unique_clicks': ((value.campaign_unique_clicks as Array<any>).map(NumberBarPointToJSON)),
        'campaign_total_bounces': ((value.campaign_total_bounces as Array<any>).map(NumberBarPointToJSON)),
        'campaign_unsubscribes': ((value.campaign_unsubscribes as Array<any>).map(NumberBarPointToJSON)),
        'campaign_total_orders': ((value.campaign_total_orders as Array<any>).map(NumberBarPointToJSON)),
        'campaign_unique_orders': ((value.campaign_unique_orders as Array<any>).map(NumberBarPointToJSON)),
        'campaign_unique_paid_orders': ((value.campaign_unique_paid_orders as Array<any>).map(NumberBarPointToJSON)),
    };
}

